import React, { useMemo } from "react";
import DestinationDeploymentConfiguratorStep from "./DestinationDeploymentConfiguratorStep";

const EndpointDeploymentConfiguratorStep = (props) => {
  const endpointContext = useMemo(() => ({
    ...props.context,
    productResourceDefaults: {
      ...(props.context?.productResourceDefaults || {}),
      checkOperationName: ""
    }
  }), [props.context]);

  return (
    <DestinationDeploymentConfiguratorStep
      {...props}
      context={endpointContext}
    />
  );
};

export default EndpointDeploymentConfiguratorStep;
